import axios from 'axios';
import _ from 'lodash';

export default function fetchCasesReports(scope, id, type = 'count', options = {}) {
  const params = _.uuCompactArrayOrObject(options);
  const request = axios.get(`/reports/${scope}/${id}/cases/${type}`, { params });
  return request
    .then((response) => _.wget(response, 'data', { data: { values: [] } }), () => ({ data: { values: [] } }));
}
